import Vue from 'vue'
import { API_URL } from '@/config'

export const reports_individual = {

  namespaced: true,

  state: {
    format: 'sheet',
    area: {}
  },

  getters: {
    format: state => state.format,
    area: state => state.area,
  },

  mutations: {
    setFormat(state, format) { state.format = format },
    toggleArea(state, area) {

      const status = state.area[area].status = !state.area[area].status;

      if (area === 'App\\Models\\Session') {
        for (let i = 0; i < state.area['App\\Models\\Session'].filters.length; i++) {
          state.area['App\\Models\\Session'].filters[i].status = status;
        }
        state.area['App\\Models\\Session'].sort = status;
        if (state.area['App\\Models\\Person'].status) {
          state.area['App\\Models\\SessionPerson'].status = status;
          for (let i = 0; i < state.area['App\\Models\\SessionPerson'].filters.length; i++) {
            state.area['App\\Models\\SessionPerson'].filters[i].status = status;
          }
          state.area['App\\Models\\SessionPerson'].sort = status;
        }
      }

      if (area === 'App\\Models\\Presentation') {
        for (let i = 0; i < state.area['App\\Models\\Presentation'].filters.length; i++) {
          state.area['App\\Models\\Presentation'].filters[i].status = status;
        }
        state.area['App\\Models\\Presentation'].sort = status;
        if (state.area['App\\Models\\Person'].status) {
          state.area['App\\Models\\PresentationPerson'].status = status;
          for (let i = 0; i < state.area['App\\Models\\PresentationPerson'].filters.length; i++) {
            state.area['App\\Models\\PresentationPerson'].filters[i].status = status;
          }
          state.area['App\\Models\\PresentationPerson'].sort = status;
        }
      }

      if (area === 'App\\Models\\Person') {
        for (let i = 0; i < state.area['App\\Models\\Person'].filters.length; i++) {
          state.area['App\\Models\\Person'].filters[i].status = status;
        }
        state.area['App\\Models\\Person'].sort = status;
        if (state.area['App\\Models\\Session'].status) {
          state.area['App\\Models\\SessionPerson'].status = status;
          for (let i = 0; i < state.area['App\\Models\\SessionPerson'].filters.length; i++) {
            state.area['App\\Models\\SessionPerson'].filters[i].status = status;
          }
          state.area['App\\Models\\SessionPerson'].sort = status;
        }
        if (state.area['App\\Models\\Presentation'].status) {
          state.area['App\\Models\\PresentationPerson'].status = (!status || !state.area['App\\Models\\Person'].status) ? false : status;
          for (let i = 0; i < state.area['App\\Models\\PresentationPerson'].filters.length; i++) {
            state.area['App\\Models\\PresentationPerson'].filters[i].status = status;
          }
          state.area['App\\Models\\PresentationPerson'].sort = status;
        }
      }

      if (area === 'App\\Models\\Session' && state.format === 'word') {
        state.format = 'sheet';
      }

    },
    setFilters(state, options) {
      for (let model in options) {
        if (model === 'App\\Models\\Participation') {
          for (let column in options[model].filters) {
            state.area['App\\Models\\SessionPerson'].filteroptions[column] = options[model].filters[column];
            state.area['App\\Models\\PresentationPerson'].filteroptions[column] = options[model].filters[column];
          }
          continue;
        }
        for (let column in options[model].filters) {
          state.area[model].filteroptions[column] = options[model].filters[column];
        }
      }
    },
    setDays(state, days) {
      state.area['App\\Models\\Session']['filteroptions']['day_id']['options'] = days.reduce((carry, day) => carry.concat([{ 
        value: day.id, 
        label: 'day', 
        name: day.date 
      }]), []);
    },
    setRooms(state, rooms) {
      state.area['App\\Models\\Session']['filteroptions']['room_id']['options'] = rooms.reduce((carry, room) => carry.concat([{ 
        value: room.id, 
        label: 'room', 
        name: room.name 
      }]), []);
    },
    setSorts(state, sorts) {
      for (let model in sorts) {
        for (let column in sorts[model]) {
          if (model === 'App\\Models\\Presentation' && column === 'assignments') continue;
          if (model === 'App\\Models\\Presentation' && Object.keys(state.area[model].sortoptions).length === 0) {
            state.area[model].sortoptions['order'] = { 
              column: 'session_presentation.order', 
              label: 'order', 
              sort: 'session_presentation.order' 
            };
          }
          if (model === 'App\\Models\\Participation') {
            // sorts['App\\Models\\SessionPerson'].state_id = sorts['App\\Models\\Participation']['state_id'];
            // sorts['App\\Models\\SessionPerson'].state_id.sort = sorts['App\\Models\\Participation']['state_id'].sort.split(',')[0];
            // state.area['App\\Models\\SessionPerson'].sortoptions['state_id'] = sorts['App\\Models\\SessionPerson']['state_id'];
            // sorts['App\\Models\\PresentationPerson'].state_id = sorts['App\\Models\\Participation']['state_id'];
            // sorts['App\\Models\\PresentationPerson'].state_id.sort = sorts['App\\Models\\Participation']['state_id'].sort.split(',')[0];
            // state.area['App\\Models\\PresentationPerson'].sortoptions['state_id'] = sorts['App\\Models\\PresentationPerson']['state_id'];
            continue;
          }
          sorts[model][column].sort = sorts[model][column].sort.split(',')[0];
          state.area[model].sortoptions[column] = sorts[model][column];
        }
      }
    },
    initializeArea(state) {
      state.area = {
        'App\\Models\\Session': { status: true, filters: [], filteroptions: {}, sort: true, sorts: [], sortoptions: {} },
        'App\\Models\\SessionPerson': { status: false, filters: [], filteroptions: {}, sort: false, sorts: [], sortoptions: {} },
        'App\\Models\\SessionPresentation': { status: true, filters: [], filteroptions: {}, sort: true, sorts: [], sortoptions: {} },
        'App\\Models\\Presentation': { status: true, filters: [], filteroptions: {}, sort: true, sorts: [], sortoptions: {} },
        'App\\Models\\PresentationPerson': { status: false, filters: [], filteroptions: {}, sort: false, sorts: [], sortoptions: {} },
        // 'App\\Models\\Participation': { status: true, filters: [], filteroptions: {}, sort: true, sorts: [], sortoptions: {} },
        'App\\Models\\Person': { status: false, filters: [], filteroptions: {}, sort: false, sorts: [], sortoptions: {} },
      };
    },
    initializeFilters(state) {
      state.area['App\\Models\\Session'].status = true;
      state.area['App\\Models\\Session'].filters = [
        { column: 'id', label: 'id', options: { type: false }, value: '', status: true },
        { column: 'code', label: 'code', options: { type: false }, value: '', status: true },
        { column: 'title', label: 'title', options: { type: false }, value: '', status: true },
      ];
      state.area['App\\Models\\Session'].sort = true;
      state.area['App\\Models\\Session'].sorts = { 
        '1': 'sessions.day_id:days:order', 
        '2': 'sessions.start_time', 
        '3': 'sessions.room_id:rooms:order', 
        '4': '',
        '5': '',
      };
      state.area['App\\Models\\SessionPerson'].status = false;
      state.area['App\\Models\\SessionPerson'].filters = [
        { column: 'role_id', label: 'role', options: { type: false, select: false }, value: '', status: false },
        { column: 'state_id', format: 'wording', label: 'participation_state', options: { type: false, select: false }, value: '', status: false },
      ];
      state.area['App\\Models\\SessionPerson'].sort = false;
      state.area['App\\Models\\SessionPerson'].sorts = { 
        '1': 'session_person.order', 
        '2': '' 
      };
      state.area['App\\Models\\SessionPresentation'].status = true;
      state.area['App\\Models\\SessionPresentation'].filters = [
        { column: 'code', label: 'code', options: { type: false }, value: '', status: true },
      ];
      state.area['App\\Models\\Presentation'].status = true;
      state.area['App\\Models\\Presentation'].filters = [
        { column: 'id', label: 'id', options: { type: false }, value: '', status: true },
        { column: 'title', label: 'title', options: { type: false }, value: '', status: true },
      ];
      state.area['App\\Models\\Presentation'].sort = true;
      state.area['App\\Models\\Presentation'].sorts = { 
        '1': 'session_presentation.order', 
        '2': '' 
      };
      state.area['App\\Models\\PresentationPerson'].status = false;
      state.area['App\\Models\\PresentationPerson'].filters = [
        { column: 'role_id', label: 'role', options: { type: false, select: false }, value: '', status: false },
        { column: 'state_id', format: 'wording', label: 'participation_state', options: { type: false, select: false }, value: '', status: false },
      ];
      state.area['App\\Models\\PresentationPerson'].sort = false;
      state.area['App\\Models\\PresentationPerson'].sorts = { 
        '1': 'presentation_person.order', 
        '2': '' 
      };
      state.area['App\\Models\\Person'].status = false;
      state.area['App\\Models\\Person'].filters = [
        { column: 'last_name', label: 'last_name', options: { type: false }, value: '', status: false },
        { column: 'first_name', label: 'first_name', options: { type: false }, value: '', status: false },
      ];
      state.area['App\\Models\\Person'].sort = false;
      state.area['App\\Models\\Person'].sorts = { 
        '1': '', 
        '2': '' 
      };
    },
  },

  actions: {

    getFilters: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: [
        'App\\Models\\Session',
        'App\\Models\\SessionPerson',
        'App\\Models\\SessionPresentation',
        'App\\Models\\Presentation',
        'App\\Models\\PresentationPerson',
        'App\\Models\\Participation',
        'App\\Models\\Person',
      ],
      filter_display: true,
    }}),

    getDays: () => Vue.axios.get(API_URL + '/days', { params: {
      sorts: [
        { 'column': 'days.order', 'order': 'asc'}
      ],
    }}),

    getRooms: () => Vue.axios.get(API_URL + '/rooms', { params: {
      sorts: [
        { 'column': 'rooms.order', 'order': 'asc'}
      ],
    }}),

    getSorts: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: [
        'App\\Models\\Session',
        'App\\Models\\SessionPerson',
        'App\\Models\\SessionPresentation',
        'App\\Models\\Presentation',
        'App\\Models\\PresentationPerson',
        'App\\Models\\Participation',
        'App\\Models\\Person',
      ],
      list_display: true,
    }}),

    async getAreas({ rootState, commit, dispatch }) {
      commit('initializeArea');
      const [filters, days, rooms, sorts] = await Promise.all([
        dispatch('getFilters'),
        dispatch('getDays'),
        dispatch('getRooms'),
        dispatch('getSorts')
      ]);
      commit('setProgress', false, { root: true });
      filters.data['App\\Models\\Person'].filters.country_code.options = filters.data['App\\Models\\Person'].filters.country_code.options.sort((a, b) => rootState._[a.name].localeCompare(rootState._[b.name]));
      commit('setFilters', filters.data);
      commit('setDays', days.data.items);
      commit('setRooms', rooms.data.items);
      commit('setSorts', sorts.data);
      commit('initializeFilters');
    },

  }
}
